import { faPen, faTrash, faQuestionCircle, faUserCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState, useMemo } from 'react';
import { AuthContext } from '../Auth/AuthContext'
import { Table, Button,Row,Col,Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom'
import { LanguageContext } from '../Language/LanguageContext';
import { TablePagination, Loading } from '../Library';
import { listVisitorReport } from '../Network/Visitor';
import { AlertModalContext } from '../Library/AlertModalContext'
import { NotifyContext } from '../Library/Notify'
import "./VisitorAllUser.css"
import axios from 'axios'
import { wtc5214,visitor8082 } from '../Network/Config'
import DatePicker from "react-datepicker";

function VisitorAllUser(props) {
    const alertModal = useContext(AlertModalContext)
    const langCx = useContext(LanguageContext)
    const notifyCx = useContext(NotifyContext);
    const lang = langCx.lang.visitor
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false)
    const [visitorReportList, setVisitorReportList] = useState([])
    const [companyName, setCompanyName] = useState("")
    const [page, setPage] = useState(1)
    const size = 10
    const [count, setCount] = useState(0)
    const [allUser, setAllUser] = useState([])
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null) 
    

    useEffect( ()=>{
        let cancelled = false;
        const fetchData = async () => {
            try {
                if (!props.companyId) return;
                setIsLoading(true)
                const formData = new FormData();
                formData.append('company_id', props.companyId);
                const responseData = await axios.post(visitor8082+'/visitor/api/v1/listcontact', formData);
                setAllUser(responseData.data.data);
                console.log('Data : ',responseData.data.data)
                setIsLoading(false)
            } catch (e) {
                console.error(e);
                setIsLoading(false)
            }
        }
    fetchData();
    return () => { cancelled = true; };
    }, [10, props.company,startDate,endDate])


    const VisitorVisitorItem = ({ id, name, email }) => {
        return(
            <tr>
                <td></td>
                <td>{id}</td>
                <td>{name}</td>
                <td>{email}</td>
            </tr>
        )
    }

    const handleUpdateUser = async () =>{
        try {
            setIsLoading(true)
            await axios.post(visitor8082+'/employee_yamaha-motor')
            .then( async (response) => {
                if(response.status == 200){
                    const formData = new FormData();
                    formData.append('company_id', props.companyId);
                    const responseData = await axios.post(visitor8082+'/visitor/api/v1/listcontact', formData);
                    setAllUser(responseData.data.data);
                }
                setIsLoading(false)
            })
            .catch((error)=>{
                console.error(error);
                setIsLoading(false)
            })
            ;
        } catch (e) {
            console.error(e);
            setIsLoading(false)
        }
    }

    return(
        <div id="visitor-report">
            { isLoading ? <Loading/> : null }
            <div className="button-container">
                <div style={{display:'flex', justifyContent:'space-between'}}>
                    <div>{lang.all_user_detail}</div>
                    <div style={{justifyContent:'flex-end'}}>
                        <Button onClick={()=>handleUpdateUser()}>{lang.update_user}</Button>
                    </div>
                </div>
            </div>
            
            <div className='table-container'>
                <Table hover>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{'ID'}</th>
                            <th>{'ชื่อ'}</th>
                            <th>{'อีเมล'}</th>
                        </tr>
                    </thead>
                    <tbody>
                        { allUser.map((item, key) =>
                        <VisitorVisitorItem
                            key={key}
                            id={item.id}
                            name={item.name}
                            email={item.email}
                        />
                            )}
                    </tbody>
                </Table>
            </div>
            <TablePagination
            dataLength={Math.ceil(count / size)}
            currentPage={page}
            size={size}
            handlerPaginationClick={(page)=>setPage(page)}
            prevClick={()=>setPage(page - 1)}
            nextClick={()=>setPage(page + 1)}
            firstPageClick={(page)=>setPage(page)}
            lastPageClick={(page)=>setPage(page)}
            disabledPrev={page === 1}
            disabledNext={page === Math.ceil(count / size)}
            />
        </div>
    )
}

export default VisitorAllUser;
